import {initScrollableHeader} from '../Utility/ScrollableHeaderUtility';

export class ScrollableHeaderController {
  private readonly scrollableHeaderElements = document.querySelectorAll('.js-scrollableHeader');

  constructor() {
    this.scrollableHeaderElements.forEach((scrollableHeaderElement) => {
      if (scrollableHeaderElement instanceof HTMLElement) {
        initScrollableHeader(scrollableHeaderElement);
      }
    });
  }

}
